import { Link } from "react-router-dom";

export function Logo({ inverse = false }: { inverse?: boolean }) {
  return (
    <Link
      to="/"
      className={`brand-logo${inverse ? " brand-logo--inverse" : ""}`}
      aria-label="ACES Travel home"
    >
      <img
        className="brand-logo__image"
        src={inverse ? "/brand/aces-logo-full.webp" : "/brand/aces-logo-nav.webp"}
        alt="ACES Travel and Tours Services"
        width={inverse ? 900 : 560}
        height={inverse ? 596 : 366}
      />
    </Link>
  );
}
